import styled from 'styled-components';

import { Colour } from '@xemplo/colours';
import {
  BodyLargeSemiBold,
  BodySmallMedium,
  BodySmallRegular,
  BodyStandardSemiBold,
} from '@xemplo/style-constants';

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 24px 32px 32px;
  background: ${Colour.Light[100]};
  border-bottom: 1px solid ${Colour.Gray[200]};
  border-radius: 8px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 32px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  & path {
    stroke: url(#primaryGradient);
  }
`;

export const Title = styled.span`
  ${BodyLargeSemiBold};
  color: ${Colour.Gray[800]};
  flex-grow: 1;
`;

/** Vertical stack of setting sections — used by both the card and the modal body. */
export const Sections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SectionHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SectionTitle = styled.span`
  ${BodyStandardSemiBold};
  color: ${Colour.Gray[800]};
`;

export const SectionDescription = styled.span`
  ${BodySmallRegular};
  color: ${Colour.Gray[400]};
`;

/** Grey rounded panel grouping a section's setting rows. */
export const SettingsGroup = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 24px;
  background: ${Colour.Gray[50]};
  border-radius: 8px;
`;

export const SettingRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid ${Colour.Gray[200]};

  &:last-child {
    border-bottom: none;
  }
`;

export const SettingLabel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const Label = styled.span`
  ${BodySmallMedium};
  color: ${Colour.Gray[800]};
`;

export const HelperText = styled.span`
  ${BodySmallRegular};
  color: ${Colour.Gray[400]};
`;
